import axios from 'axios';

export const getNotificationTemplates = (token, params = {}) => {
    return axios.get('/notification-template', {
        headers: { Authorization: token },
        params,
    });
};

export const createNotificationTemplate = (payload, token) => {
    return axios.post('/notification-template', payload, {
        headers: { Authorization: token },
    });
};

export const updateNotificationTemplate = (id, payload, token) => {
    return axios.put(`/notification-template/${id}`, payload, {
        headers: { Authorization: token },
    });
};

export const getNotificationTemplateHistory = (id, token) => {
    return axios.get(`/notification-template/history/${id}`, {
        headers: { Authorization: token },
    });
};
